import React from "react";
import MenuModel from "../../Models/MenuModel";

function MenuCircle({
  element,
  name,
  props,
  IMG_URl,
}: {
  element: MenuModel;
  name: keyof MenuModel;
  props: any;
  IMG_URl: string;
}) {
  const isActive = element.id == props.selectedMenu;
  const hasSelectedMenu = !!props.selectedMenu;

  return (
    <div
      key={element.id}
      className={`relative flex flex-col items-center gap-2 cursor-pointer transition-all duration-300 shrink-0 ${
        isActive ? "menu-active" : ""
      }`}
      onClick={() =>
        element.id !== props.selectedMenu ? props.onClickMenu(element.id) : null
      }
    >
      <div
        className={`relative transition-all duration-300 rounded-2xl ${
          isActive
            ? "scale-110 shadow-lg shadow-primary/20 ring-2 ring-primary ring-offset-2 ring-offset-background"
            : "hover:scale-105"
        } ${
          hasSelectedMenu && !isActive ? "opacity-75 hover:opacity-100" : ""
        }`}
      >
        <div
          className={`absolute inset-0 rounded-2xl transition-all duration-300 ${
            isActive
              ? "bg-primary/5 border border-primary/25"
              : "bg-transparent border border-transparent"
          }`}
        />
        <img
          alt={element.name_en}
          src={`${IMG_URl}${element.image}`}
          className="object-cover bg-background w-24 h-20 md:w-28 md:h-24 rounded-2xl"
        />
      </div>
      <p
        className={`text-center font-semibold transition-all duration-300 ${
          isActive
            ? "text-sm md:text-base text-onPrimary font-bold"
            : "text-xs md:text-sm text-foreground/85"
        }`}
      >
        {element[name]}
      </p>
    </div>
  );
}

export default MenuCircle;
